<template>
  <div class="plat-form-wrap">
    <div class="slides-wrap">
      <a-carousel arrows>
        <div
          class="need_dot-item"
          :style="{ backgroundImage: `url(${bgImg})` }"
        ></div>
      </a-carousel>
      <div class="text_line1">
        精准实现
      </div>
      <div class="text_line2">
        供需匹配
      </div>
      <div class="libarary-imgText">
        <div class="btn technicalBtn" @click="toRouter('techDealInfos')">
          查看全部
        </div>
      </div>
    </div>
    <div class="body-wrap home-mini-width">
      <MarketDemand></MarketDemand>
      <!-- <div class="technicalrlibrary-content">
        <TitleCard
        title="战略产业"
        :loading="loadingNew"
        :isEmpty="isEmptyNew"
        :type="'firstCard'"
        :showMore="false"
        @moreClick="toRouter('dealInfos')"
      >
          <StrategicIndustry></StrategicIndustry>
      </TitleCard>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Mixin } from './mixins'
// import StrategicIndustry from './components/strategicIndustry.vue'
import MarketDemand from '@/views/MPlatformPortal/components/MarketDemand'
const industryList = require('@/utils/industryList')
export default {
  data() {
    return {
      bgImg: require('@/assets/images/zhonshanImg/need_banner_notext.png'),
      tabs: industryList.industryLists
    }
  },
  mixins: [Mixin],
  components: {
    MarketDemand
  },
  mounted() {
    this.init()
  },
  methods: {
    toRouter(router) {
      this.$router.push({
        name: router,
        params: { selectVal: JSON.stringify(this.selectVal) }
      })
    },
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectedTab = val.tab.name
      this.params.industrialType = val.tab.key
      this.selectVal = val.tab
      this.init()
    }
  }
}
</script>
